const state = {
    booking: null,
    procedures: [],
};

const getters = {
    getBooking: (state) => state.booking,
    getProcedures: (state) => state.procedures,
    getProcedureCount: (state) => state.procedures.length,
};

const actions = {
    setBooking({ commit }, booking) {
        commit("updateBooking", booking);
    },
    setProcedures({ commit }, procedures) {
        commit("updateProcedures", procedures);
    },
    addProcedure({ commit }, procedure) {
        commit("addProcedure", procedure);
    },
    removeProcedure({ commit }, procedureId) {
        commit("removeProcedure", procedureId);
    },
    resetState({ commit }) {
        commit("reset");
    }
};

const mutations = {
    updateBooking(state, booking) {
        state.booking = booking;
    },
    updateProcedures(state, procedures) {
        state.procedures = procedures;
    },
    reset(state) {
        state.booking = null;
        state.procedures = [];
    },
    addProcedure({ state }, procedure) {
        if (state.procedures.find(p => p.id === procedure.id)) return;
        this.procedures.push(procedure);
    },
    removeProcedure({ state }, procedureId) {
        state.procedures = state.procedures.filter(p => p.id !== procedureId);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}